import { HomePageEntity } from '@/modules/homepage/domain/entities/HomePageEntity';
import { coreHomepagesCoreRoute } from '@/modules/homepage/domain/routes/homepageRoutes';
import { requestQuery } from '@/services/request';
import { DomainTypes } from '@/types';
import { Homepage } from '@/types/homepage';
import { Langs } from '@/types/lang';

export const getHomepage = async (category?: string): Promise<Homepage> => {
  const response = await requestQuery<Homepage>({
    url: coreHomepagesCoreRoute,
    params: {
      lang: Langs.Fr,
      ...(category && { category }),
    },
  });

  return response && new HomePageEntity({ ...response, source: DomainTypes.Internal });
};
